import { useEffect, useState } from 'react'
import { getDictionary } from 'services/api/dictionary'
import { getUserInfoCache } from 'utils/user-info'

const Whatsapp = ({
  location = 'bookdetail',
  children,
}: {
  location?: string
  children: JSX.Element | JSX.Element[]
}): JSX.Element => {
  const [link, setLink] = useState('')
  useEffect(() => {
    const userInfo = getUserInfoCache()
    getDictionary('NEW_ANYSTORIES_WEB_WHATS_APP_ENTER_INFO_CONFIG').then(
      (data) => {
        if (userInfo) {
          setLink(
            data[location]['user']
              .replaceAll('LOCATION', location)
              .replaceAll('USERNAME', userInfo.name)
              .replaceAll('USERUNIQUEID', 'uid_' + userInfo.id)
          )
        } else {
          setLink(data[location]['default'])
        }
      }
    )
  }, [])

  return (
    <a href={`${link}`} target="_blank" rel="noreferrer">
      {children}
    </a>
  )
}

export default Whatsapp
